import { cn } from "@/lib/utils";

interface PostureScoreProps {
  score: number;
  className?: string;
}

function getScoreColor(score: number): string {
  if (score >= 90) return "text-green-500";
  if (score >= 70) return "text-yellow-500";
  if (score >= 50) return "text-orange-500";
  return "text-red-500";
}

function getGradient(score: number): string {
  if (score >= 90) return "#22c55e";
  if (score >= 70) return "#eab308";
  if (score >= 50) return "#f97316";
  return "#ef4444";
}

export function PostureScore({ score, className }: PostureScoreProps) {
  const color = getGradient(score);
  const angle = (score / 100) * 360;

  return (
    <div className={cn("flex flex-col items-center gap-2", className)}>
      <div
        className="relative flex h-32 w-32 items-center justify-center rounded-full"
        style={{
          background: `conic-gradient(${color} ${angle}deg, hsl(var(--muted)) ${angle}deg 360deg)`,
        }}
      >
        <div className="flex h-24 w-24 items-center justify-center rounded-full bg-background">
          <span className={cn("text-3xl font-bold", getScoreColor(score))}>
            {score}
          </span>
        </div>
      </div>
      <span className="text-sm font-medium text-muted-foreground">
        Posture Score
      </span>
    </div>
  );
}
